import {EnvironmentModel, IOHURLS} from './environment.model';
import {Endpoints} from "./endpoints";


// export const IOH: IOHURLS = {
//   patientServiceBaseURL: 'https://portal.snd.iohealthtech.com',
//   userServiceBaseURL: 'https://portal.snd.iohealthtech.com',
//   rulesServiceBaseUrl: 'https://portal.snd.iohealthtech.com',
//   reportsServiceBaseUrl: 'https://portal.snd.iohealthtech.com',
// }

export const IOH: IOHURLS = {
  patientServiceBaseURL: 'https://portal.uat.iohealthtech.com',
  userServiceBaseURL: 'https://portal.uat.iohealthtech.com',
  rulesServiceBaseUrl: 'https://portal.uat.iohealthtech.com',
  reportsServiceBaseUrl: 'https://portal.uat.iohealthtech.com',
}

const endpoints = new Endpoints()
export const environment: EnvironmentModel= {
  production: false,
  cognito: {
    userPoolId: 'us-east-1_SUCPgjgWT',
    userPoolWebClientId: '30tp4ib1090m2vg6to24oa4gte',
    region: 'us-east-1',
  },
  endPoints: { ...endpoints.getGenericEndpoints()},
  awsCredentials: {
    region: "us-east-2",
    signatureVersion: "v4"
  }
}

